import { useSelector } from "react-redux";
import Share from "../../../../components/Share/component";
import CommentsCount from "../CommentCount/component";
import "./styles/themes/_default.scss";

const EngagementWidgets = ({ storyId, isPreview }) => {
    const isWebView = useSelector((state) => state.fixed.isWebView);
    const meta = useSelector((state) => state.app.meta);

    return (
        <div className="engagement-widgets" data-testid="engagementWidgets">
            {!isWebView && !isPreview && (
                <Share path={meta["vf:url"]} key={storyId} />
            )}
            {<CommentsCount storyId={storyId} />}
        </div>
    );
};

export default EngagementWidgets;
